module.exports = __webpack_public_path__ + "static/media/curtains-tip.f82b9129.svg";